module.exports = "<div class=\"columns\" *ngIf=\"isLoggedIn\">\n\n  <div class=\"column is-half-desktop is-flex-tablet\">\n    <app-entries></app-entries>\n  </div>\n\n  <div class=\"column is-half-desktop is-flex-tablet\">\n    <app-clients></app-clients>\n  </div>\n\n</div>\n\n<div class=\"section\" *ngIf=\"isLoggedIn\">\n  <app-body-editer></app-body-editer>\n</div>\n<!--\n<div class=\"section\" *ngIf=\"isLoggedIn\">\n  <app-map-editer></app-map-editer>\n</div> -->\n\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin.component.html
// module id = ./src/app/components/admin/admin.component.html
// module chunks = main